<h2 mat-dialog-title>Select export columns</h2>

<mat-dialog-content class="dialog-body">
  <div class="header-actions">
    <button mat-stroked-button type="button" (click)="selectAll()">Select all</button>
    <button mat-stroked-button type="button" (click)="selectNone()">Select none</button>
    <button mat-stroked-button type="button" (click)="selectDefaults()">Reset to defaults</button>
    <span class="count">{{ selectedCount }} selected</span>
  </div>

  @for (group of groups; track group) {
    <section class="group">
      <header class="group-header">
        <mat-checkbox
          [checked]="isGroupAllSelected(group)"
          [indeterminate]="isGroupAnySelected(group) && !isGroupAllSelected(group)"
          (change)="toggleGroup(group, $event.checked)">
          <strong>{{ group }}</strong>
        </mat-checkbox>
      </header>
      <div class="group-items">
        @for (col of columnsInGroup(group); track col.id) {
          <mat-checkbox [(ngModel)]="col.selected">{{ col.header }}</mat-checkbox>
        }
      </div>
    </section>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button"
          [disabled]="selectedCount === 0"
          (click)="confirm()">
    <mat-icon>file_download</mat-icon>
    Export {{ selectedCount }} column{{ selectedCount === 1 ? '' : 's' }}
  </button>
</mat-dialog-actions>
